import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import api from "@/lib/api";
import { FadeIn } from "@/components/site/Shared";

export default function BlogDetail() {
  const { slug } = useParams();
  const [post, setPost] = useState(null);

  useEffect(() => {
    api.get(`/blog/${slug}`).then(({ data }) => setPost(data)).catch(() => setPost(false));
  }, [slug]);

  if (post === null) return <div className="min-h-[60vh] flex items-center justify-center text-silver uppercase tracking-widest text-sm">Loading…</div>;
  if (post === false) return <div className="min-h-[60vh] flex items-center justify-center text-silver">Article not found.</div>;

  return (
    <div data-testid="blog-detail-page">
      <section className="border-b border-line">
        <div className="max-w-4xl mx-auto px-5 sm:px-8 py-20">
          <FadeIn>
            <Link to="/blog" className="inline-flex items-center gap-2 text-silver text-xs uppercase tracking-[0.2em] hover:text-ember transition-colors duration-200 mb-10">
              <ArrowLeft size={14} /> All Insights
            </Link>
            <div className="flex items-center gap-4 text-xs uppercase tracking-[0.2em] mb-5">
              <span className="text-ember font-bold">{post.category}</span>
              <span className="text-silver">{post.date}</span>
              <span className="text-silver">· {post.author}</span>
            </div>
            <h1 className="font-heading text-3xl sm:text-4xl lg:text-5xl uppercase tracking-tighter text-white leading-[1]">{post.title}</h1>
          </FadeIn>
        </div>
      </section>
      <div className="max-w-4xl mx-auto px-5 sm:px-8">
        <div className="border border-line overflow-hidden -mt-0 my-14">
          <img src={post.image} alt={post.title} className="w-full h-[380px] object-cover" />
        </div>
        <article className="pb-24" data-testid="blog-article-body">
          {post.content.split("\n\n").map((para, i) => (
            <p key={`${i}-${para.slice(0, 24)}`} className="text-white/85 leading-[1.9] mb-6 text-base">{para}</p>
          ))}
        </article>
      </div>
    </div>
  );
}
